export default function OutlinedPaperClipBG() {
  return (
    <svg
      width="27"
      height="25"
      viewBox="0 0 27 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M26.2264 10.125C26.9409 11.3626 26.9409 12.8874 26.2264 14.125L21.5358 22.2494C20.8213 23.487 19.5008 24.2494 18.0717 24.2494L8.6905 24.2494C7.26144 24.2494 5.94093 23.487 5.2264 22.2494L0.5358 14.125C-0.178731 12.8874 -0.178731 11.3626 0.535802 10.125L5.2264 2.00064C5.94093 0.763039 7.26144 0.000643804 8.6905 0.000643867L18.0717 0.000644277C19.5008 0.000644339 20.8213 0.76304 21.5358 2.00064L26.2264 10.125Z"
        fill="#F5E8F9"
      />
      <g clipPath="url(#clip0_5942_17537)">
        <path
          d="M17.0356 7.81357C15.7477 6.52568 13.6505 6.52568 12.3639 7.81357L8.79557 11.3792C8.77233 11.4024 8.76002 11.4339 8.76002 11.4667C8.76002 11.4995 8.77233 11.531 8.79557 11.5542L9.30006 12.0587C9.32312 12.0817 9.35434 12.0945 9.38688 12.0945C9.41942 12.0945 9.45063 12.0817 9.47369 12.0587L13.0421 8.49307C13.485 8.0501 14.0743 7.80674 14.7005 7.80674C15.3266 7.80674 15.9159 8.0501 16.3575 8.49307C16.8005 8.93603 17.0438 9.52529 17.0438 10.1501C17.0438 10.7763 16.8005 11.3642 16.3575 11.8071L12.7208 15.4425L12.1315 16.0317C11.5805 16.5827 10.685 16.5827 10.134 16.0317C9.86744 15.7651 9.72116 15.411 9.72116 15.0337C9.72116 14.6563 9.86744 14.3022 10.134 14.0356L13.7421 10.429C13.8337 10.3388 13.954 10.2882 14.0825 10.2882H14.0839C14.2124 10.2882 14.3313 10.3388 14.4215 10.429C14.5131 10.5206 14.5624 10.6409 14.5624 10.7694C14.5624 10.8966 14.5118 11.0169 14.4215 11.1071L11.4725 14.0534C11.4493 14.0767 11.437 14.1081 11.437 14.1409C11.437 14.1737 11.4493 14.2052 11.4725 14.2284L11.977 14.7329C12.0001 14.7559 12.0313 14.7688 12.0638 14.7688C12.0964 14.7688 12.1276 14.7559 12.1506 14.7329L15.0983 11.7853C15.3704 11.5132 15.5194 11.1522 15.5194 10.7681C15.5194 10.3839 15.369 10.0216 15.0983 9.75088C14.5364 9.18896 13.6231 9.19033 13.0612 9.75088L12.7112 10.1022L9.45455 13.3575C9.23352 13.5773 9.05831 13.8387 8.93909 14.1267C8.81987 14.4146 8.759 14.7234 8.76002 15.0351C8.76002 15.6681 9.00748 16.2628 9.45455 16.7099C9.91803 17.172 10.5251 17.403 11.1321 17.403C11.7391 17.403 12.3462 17.172 12.8083 16.7099L17.0356 12.4853C17.6577 11.8618 18.0022 11.0319 18.0022 10.1501C18.0036 9.26689 17.659 8.43701 17.0356 7.81357Z"
          fill="#700F94"
        />
      </g>
      <defs>
        <clipPath id="clip0_5942_17537">
          <rect
            width="14"
            height="14"
            fill="white"
            transform="translate(6.3811 5.125)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
